import { useMutation, useQueryClient } from "react-query";

import { Family } from "../../types";
import FamilyService from "../../services/Family";

import { QUERY_KEY } from "./useListFamilies";

function useUpdateFamily() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ id, ...updates }: { id: Family["id"] } & Partial<Family>) =>
      FamilyService.updateFamily(id, updates),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY);
      },
    }
  );
}

export default useUpdateFamily;
